export default __webpack_public_path__ + "static/crunch-86073dd8905ecf22aef3f53cebb3579f.png";